import React from "react";
import { getMarket, setMarket, SUPPORTED_MARKETS, MARKETS } from "../services/api";

// Sélecteur de marché (.fr / .es) affiché dans la navbar, en interrupteur à deux positions.
// Au changement, on persiste le marché puis on recharge la page : tous les
// écrans rechargent leurs données au montage, donc un reload suffit à basculer
// tout le back-office sur le nouveau marché sans câbler du state global partout.
const MarketSelector = () => {
  const current = getMarket();

  const changeMarket = (market) => {
    if (market === current) return;
    setMarket(market);
    window.location.reload();
  };

  return (
    <li className="nav-item d-flex align-items-center mr-3">
      <div className="trc-market" role="group" aria-label="Marché">
        {SUPPORTED_MARKETS.map((market) => (
          <button
            key={market}
            type="button"
            className={market === current ? "on" : ""}
            aria-pressed={market === current}
            title={MARKETS[market].label}
            onClick={() => changeMarket(market)}
          >
            <span className="trc-market-flag">{MARKETS[market].flag}</span>
            {MARKETS[market].label.replace(/\s*\(.*\)$/, "")}
          </button>
        ))}
      </div>
    </li>
  );
};

export default MarketSelector;
